import { render, staticRenderFns } from "./SvgInfoIcon.vue?vue&type=template&id=fbaa894e&scoped=true"
import script from "./SvgInfoIcon.vue?vue&type=script&lang=js"
export * from "./SvgInfoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbaa894e",
  null
  
)

export default component.exports